import { type I18NLocale } from './Locale.types';

export function isI18NLocale(input: unknown): input is I18NLocale {
    return typeof input === 'object' && input !== null && 'key' in input;
}
